import * as React from 'react';
import "./styles.css";

//
// An animated spinning ring that indicates that an operation is in progress.
//

export enum LoadingSpinnerSize {
    Small,
    Medium,
    Large
}

export interface LoadingSpinnerProps {
    size?: LoadingSpinnerSize;
    enabled?: boolean;
}

export class LoadingSpinner extends React.PureComponent<LoadingSpinnerProps> {
    public constructor(props: LoadingSpinnerProps) {
        super(props);
    }

    // ===============================================================================

    public render() {
        const size = this.props.size ?? LoadingSpinnerSize.Small;
        const enabled = this.props.enabled ?? true;

        let sizeClass = "small";

        switch (size) {
            case LoadingSpinnerSize.Small:
                sizeClass = "small";
                break;
            case LoadingSpinnerSize.Medium:
                sizeClass = "medium";
                break;
            case LoadingSpinnerSize.Large:
                sizeClass = "large";
                break;
        }

        if (!enabled) {
            return null;
        }

        return (
            <div className={`tn-loading-spinner ${sizeClass}`}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        );
    }
}